<template lang="pug">
  aside.assets-selector
    asset-list(:isBase="true", :assets="assets", :selected-asset="selectedBaseAsset")
    .swap(@click="swapAssets")
      .icon ⇋
    asset-list(:isBase="false", :assets="assets", :selected-asset="selectedQuoteAsset")
</template>

<script>
  import AssetList from './AssetPairSelector/List.vue'
  import { mapActions } from 'vuex'

  let assets = [
    {
      code: 'XLM',
      image: 'http://icons.iconarchive.com/icons/cjdowner/cryptocurrency-flat/1024/Stellar-XLM-icon.png',
      host: 'https://stellar.org'
    },
    {
      code: 'BTC',
      issuer: 'GBSTRH4QOTWNSVA6E4HFERETX4ZLSR3CIUBLK7AXYII277PFJC4BBYOG',
      image: 'https://stronghold.co/img/Stronghold-Logo-100x100.png',
      host: 'https://stronghold.co'
    },
    {
      code: 'ETH',
      issuer: 'GBSTRH4QOTWNSVA6E4HFERETX4ZLSR3CIUBLK7AXYII277PFJC4BBYOG',
      image: 'https://stronghold.co/img/Stronghold-Logo-100x100.png',
      host: 'https://stronghold.co'
    },
    {
      code: 'MOBI',
      issuer: 'GA6HCMBLTZS5VYYBCATRBRZ3BZJMAFUDKYYF6AH6MVCMGWMRDNSWJPIH',
      image: 'https://mobius.network/mobi.png',
      host: 'https://mobius.network'
    },
    {
      code: 'CNY',
      issuer: 'GAREELUB43IRHWEASCFBLKHURCGMHE5IF6XSE7EXDLACYHGRHM43RFOX',
      image: null,
      host: 'https://ripplefox.com'
    },
    {
      code: 'XRP',
      issuer: 'GA7FCCMTTSUIC37PODEL6EOOSPDRILP6OQI5FWCWDDVDBLJV72W6RINZ',
      image: null
    },
    {
      code: 'XCN',
      issuer: 'GA7FCCMTTSUIC37PODEL6EOOSPDRILP6OQI5FWCWDDVDBLJV72W6RINZ',
      image: null
    },
    {
      code: 'JPY',
      issuer: 'GA7FCCMTTSUIC37PODEL6EOOSPDRILP6OQI5FWCWDDVDBLJV72W6RINZ',
      image: null
    }
  ]

  export default {
    components: {
      AssetList
    },
    data () {
      return {
        assets,
        selectedBaseAsset: assets[1],
        selectedQuoteAsset: assets[0]
      }
    },
    methods: {
      ...mapActions(['swapAssets'])
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"

  .assets-selector
    position: fixed
    top: 0
    z-index: 10

    display: grid
    grid-template-rows: 1fr 5em 1fr

    width: $asset-selector-width
    height: 100vh

    border-right: $border

  .swap
    display: flex
    justify-content: center
    align-items: center

    background-color: white

    border: $border
    border-right: none
    border-left: none

    cursor: pointer

    .icon
      font-size: 2rem
      transform: rotate(90deg)
      opacity: 0.9
</style>
